import { analytics } from "../../firebase-config";
import { logEvent } from "firebase/analytics";
import ReactGA from "react-ga4";

//  Firebase tracking
// This is used to track which external website the user comes from
export const logReferrer = () => {
  if (analytics && typeof window !== "undefined" && window.referrerURL) {
    logEvent(analytics, "referrer", {
      referrer_url: window.referrerURL,
    });
  }
};

export const logAnalyticsEvent = (eventName, params) => {
  if (analytics) {
    logEvent(analytics, eventName, params);
  }
};

//  GA tracking
export const logGAPageView = (eventName, params) => {
  console.log("inside logGAPageView:", eventName, params);
  ReactGA.send({
    hitType: eventName,
    page_path: params.page_path,
    page_params: params.page_params,
  });
};

// GTAG tracking
export const trackGtagEvent = (eventName, params = {}) => {
  if (typeof window !== "undefined") {
    if (window.gtag) {
      window.gtag("event", eventName, {
        event_category: params.event_category,
        event_label: params.event_label,
        value: params.value,
      });
    } else {
      console.debug("Gtag not found", { eventName, params });
    }
  }
};

// App download intent conversion
export const trackGoogleAdsAppDownloadIntent = (platform, callback) => {
  const platformConversions = {
    iOS: "AW-17034300624/kIDuCN7F1skaENCZy7o_",
    Android: "AW-17034300624/O5HCCOHF1skaENCZy7o_",
  };

  const sendToId = platformConversions[platform];

  if (typeof window !== "undefined" && window.gtag && sendToId) {
    window.gtag("event", "conversion", {
      send_to: sendToId,
      event_callback: callback,
    });
  } else {
    console.debug("Gtag not found for conversion or invalid platform", {
      platform,
      sendToId,
    });
    if (callback) callback();
  }
};

// Facebook Pixel tracking
export const trackPixel = (eventName, params = {}) => {
  if (typeof window !== "undefined") {
    if (window.fbq) {
      window.fbq("track", eventName, params);
    } else {
      console.debug("trackPixel(): fbq not found", { eventName, params });
    }
  }
};

// OpenAI (ChatGPT Ads) pixel. Built-in event names only, e.g. "lead_created".
// the loader in gatsby-ssr.js queues calls until the SDK has arrived.
export const trackOpenAiPixel = (eventName, params) => {
  if (typeof window !== "undefined") {
    if (window.oaiq) {
      window.oaiq("measure", eventName, params);
    } else {
      console.debug("trackOpenAiPixel(): oaiq not found", {
        eventName,
        params,
      });
    }
  }
};

// Store button click, with the page's campaign tag, so GA4 can report which
// pages send people to the stores.
export const trackStoreClick = (platform, campaign) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "store_click", {
      platform,
      campaign,
      page_path: window.location.pathname,
    });
  }
};
